import apiCacheReducer from './api-cache'
import authCodeReducer from './auth-code'
import authReducer from './auth'
import formReducer from './form'
import genericSlice from './generic-slice'
import pagerReducer from './pager'


const BLANK_OBJ = {}
const BLANK_LIST = []

const indexReducer = {
    account: genericSlice('ACCOUNT', BLANK_OBJ),
    accountType: genericSlice('ACCOUNT_TYPE', BLANK_OBJ),
    adminAgents: genericSlice('ADMIN_AGENTS', BLANK_LIST),
    adminPayouts: genericSlice('ADMIN_PAYOUTS', BLANK_LIST),
    adminReceipts: genericSlice('ADMIN_RECEIVED_COMMISSIONS', BLANK_LIST),
    agents: genericSlice('AGENTS', BLANK_LIST),
    apiCaches: apiCacheReducer,
    auth: authReducer,
    authCode: authCodeReducer,
    commissions: genericSlice('COMMISSIONS', BLANK_LIST),
    forms: formReducer,
    invitations: genericSlice('INVITATIONS', BLANK_LIST),
    itineraries: genericSlice('LUNA_ITINERARIES', BLANK_LIST),
    leads: genericSlice('LEADS', BLANK_LIST),
    onboards: genericSlice('LUNA_ONBOARDS', BLANK_LIST),
    paginator: pagerReducer,
    role: genericSlice('ROLE', BLANK_OBJ),
    travelers: genericSlice('LUNA_TRAVELERS', BLANK_LIST),
    trips: genericSlice('LUNA_TRIPS', BLANK_LIST),
    user: genericSlice('USER', BLANK_OBJ)
}

export default indexReducer
